<template>
  <div>
    <Form ref="searchForm" :model="searchForm" :label-width="110">
      <div v-if="showMoreCondition" ref='formItemContainer' class="condition-container">
        <Row>
          <Col  :xs="24" :sm="24" :lg="8" v-if="formItems.includes('countries')">
            <FormItem :label-width="90" style="margin-bottom: 10px;"
                      :label="$t('label.project.country')">
              <Select v-model="searchForm.countries" :max-tag-count="0" class="" clearable filterable multiple
                      :placeholder="$t('label.country')"
                      transfer>
                <Icon v-if="searchForm.countries && searchForm.countries.length > 0" type="md-close-circle" slot="prefix"
                      style="display: flex;" @click.stop="searchForm.countries=[]"/>
                <template v-for="par in countryList">
                  <OptionGroup :key="par.title" :label="par.title ? par.title: $t('label.continent')">
                    <Option v-for="child in par.children" :key="child.id" :value="JSON.stringify(child)">{{
                      child.title
                      }}
                    </Option>
                  </OptionGroup>
                </template>
              </Select>
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="24" :lg="8" v-if="formItems.includes('industries')">
            <FormItem :label-width="90" style="margin-bottom: 10px;"
                      :label="$t('label.project.industry')">
              <Select v-model="searchForm.industries" :max-tag-count="0" :max-tag-placeholder="maxTagPlaceholder" class=""
                      clearable filterable
                      multiple :placeholder="$t('label.industry')" transfer>
                <Icon v-if="searchForm.industries && searchForm.industries.length > 0" type="md-close-circle" slot="prefix"
                      style="display: flex;" @click.stop="searchForm.industries=[]"/>
                <Option v-for="item in industryList" :key="item.id" :value="JSON.stringify(item)">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="24" :lg="8" v-if="formItems.includes('enterprises')">
            <FormItem :label-width="90" style="margin-bottom: 10px;"
                      :label="$t('label.project.enterprise')">
              <Select v-model="searchForm.enterprises" :max-tag-count="0" :max-tag-placeholder="maxTagPlaceholder"
                      class="" clearable filterable
                      multiple :placeholder="$t('label.enterprise')" transfer>
                <Icon v-if="searchForm.enterprises && searchForm.enterprises.length > 0" type="md-close-circle"
                      slot="prefix" style="display: flex;" @click.stop="searchForm.enterprises=[]"/>
                <Option v-for="item in companyList" :key="item.id" :value="JSON.stringify(item)">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="24" :lg="8" v-if="formItems.includes('categories')">
            <FormItem :label-width="90" style="margin-bottom: 10px;"
                      :label="$t('label.information.category')">
              <Select v-model="searchForm.categories" :max-tag-count="0" :max-tag-placeholder="maxTagPlaceholder" class=""
                      clearable filterable multiple
                      :placeholder="$t('label.information.category')" transfer @on-change="changeType">
                <Icon v-if="searchForm.categories && searchForm.categories.length > 0" type="md-close-circle" slot="prefix"
                      style="display: flex;" @click.stop="searchForm.categories=[]"/>
                <Option v-for="item in typeModels" :key="item.id" :value="JSON.stringify(item)">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="24" :lg="8" v-if="formItems.includes('stages')">
            <FormItem :label-width="90" style="margin-bottom: 10px;"
                      :label="$t('label.project.stage')">
              <Select v-model="searchForm.stages" :max-tag-count="0" :max-tag-placeholder="maxTagPlaceholder" clearable
                      filterable
                      multiple :placeholder="$t('label.stage')" transfer>
                <Icon v-if="searchForm.stages && searchForm.stages.length > 0" type="md-close-circle" slot="prefix"
                      style="display: flex;" @click.stop="searchForm.stages=[]"/>
                <Option v-for="item in stageModels" :key="item.id" :value="JSON.stringify(item)">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="24" :lg="8" v-if="formItems.includes('amount')">
            <FormItem :label-width="90" style="margin-bottom: 10px;"
                      :label="$t('label.project.amount')">
              <Select v-model="searchForm.amount" :max-tag-count="0" :max-tag-placeholder="maxTagPlaceholder" clearable
                      filterable
                      multiple :placeholder="$t('label.amount')" transfer>
                <Icon v-if="searchForm.amount && searchForm.amount.length > 0" type="md-close-circle" slot="prefix"
                      style="display: flex;" @click.stop="searchForm.amount=[]"/>
                <Option v-for="item in amountModels" :key="item.id" :value="JSON.stringify({id:item.id, title:item.title})">
                  {{ item.title }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="24" :lg="8" v-if="formItems.includes('source')">
            <FormItem :label-width="90" style="margin-bottom: 10px;"
                      :label="$t('label.information.detail.source')">
              <Input v-model="searchForm.source" :placeholder="$t('label.source')" clearable />
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="24" :lg="8">
            <FormItem :label-width="90" style="margin-bottom: 10px;" :label="$t('label.project.date')">
              <DatePicker
                transfer
                :value="searchForm.pdate"
                :options="dateOptions"
                @on-change="(val) => {searchForm.pdate = val}"
                format="yyyy-MM-dd"
                type="daterange"
                :editable="false"
                clearable
                placement="bottom-start"
                :placeholder="$t('label.date')"
                style="width: 100%;">
              </DatePicker>

              <!--<Select v-model="searchForm.date" :max-tag-count="0" :max-tag-placeholder="maxTagPlaceholder" clearable
                      filterable multiple :placeholder="$t('label.theDateRange')"
                      transfer>
                <Icon v-if="searchForm.date && searchForm.date.length > 0" type="md-close-circle" slot="prefix"
                      style="display: flex;" @click.stop="searchForm.date=[]"/>
                <Option v-for="item in dateModels" :key="item.id" :value="JSON.stringify({id:item.id, title:item.title})">
                  {{ item.title }}
                </Option>
              </Select>-->
            </FormItem>
          </Col>
        </Row>
      </div>

      <div style="margin-bottom: 10px;">
        <AutoComplete
            clearable
            v-model="searchForm.keywords"
            transfer
            @on-focus="()=> {this.associationWordsList=[]}"
            @on-search="associationWords"
            :placeholder="$t('placeholders.information.keywords')" class="auto-complete">
          <Option v-for="item in associationWordsList" :value="item" :key="item">{{ item }}</Option>
        </AutoComplete>
        <iSwitch :class="{'switch-en': isEN}" size="large" true-value="1" false-value="0" v-model="searchForm.searchModel">
          <span slot="open" :class="{'ivu-switch-inner-en': isEN}">{{ $t('buttons.switch.accurate') }}</span>
          <span slot="close">{{ $t('buttons.switch.fuzzy') }}</span>
        </iSwitch>
        <Button style="" type="primary" @click="okBtn">{{ $t('buttons.search') }}</Button>
        <Button style="" @click="reset">{{ $t('buttons.reset') }}</Button>
        <!--        <Button style="color: #008bce;padding: 5px;cursor: pointer;" type="text" @click="openHistory" v-html="$t('buttons.searchHistory')">{{ $t('buttons.searchHistory') }}</Button>-->
        <el-link type="text" :underline="false" @click="openHistory" style="color: #008bce;cursor: pointer;"
                 class="padding5" v-html="$t('buttons.searchHistory')"></el-link>
        <el-link v-if="showMoreCondition" class="padding5" type="default" :underline="false" @click="moreConditionClick(false)" v-html="$t('buttons.advanceRetrieval',{ type: 'up' })"></el-link>
        <el-link v-else class="padding5" type="default" :underline="false" @click="moreConditionClick(true)" v-html="$t('buttons.advanceRetrieval',{ type: 'down' })"></el-link>
      </div>
      <div v-if="showMoreCondition" v-show="Object.keys(myCondition).length > 0" class="my-condition-box" style="padding-right: 50px;">
        <label style="float:left;line-height: 27px;">{{ $t('label.project.searchCondition') }}：</label>
        <div style="margin-left: 110px;">
          <p v-for="(item,key) in myCondition" :key="key">
            <label>{{ item.tag }}：</label>
            <template v-if="key === 'pdate'">
                <span class="condition-text">
                  {{ item.list.join(' - ') }}
                </span>
            </template>
            <template v-else-if="key === 'source'">
                <span class="condition-text">
                  {{ item.list }}
                </span>
            </template>
            <template v-else>
              <span v-for="(obj,i) in item.list" :key="i">
                <span class="condition-text">
                  <i class="el-icon-error condition-item-close"
                     @click="item.list.splice(i,1)"></i>{{ JSON.parse(obj).title }}
                </span>
                {{ i === item.list.length - 1 ? '' : '，' }}
              </span>
            </template>
            <i class="el-icon-circle-close condition-close" @click="key === 'source' ? searchForm[key] = '' : searchForm[key] = []"></i>
          </p>
        </div>
      </div>
    </Form>
    <div class="table-top-box">
    <span class="fl ">
       <Checkbox style="margin:0 13px 0 13px;"
                 :indeterminate="indeterminate"
                 :value="checkAll"
                 @on-change="handleCheckAll"></Checkbox>
       <Divider type="vertical"/>
      <!-- <Checkbox v-model="newInfoAllCheck" style="float:left;margin:0 0 0 10px;"></Checkbox> -->
      <!--      <RadioGroup v-model="searchForm.sort" style="margin:0 0 0 20px;" @on-change="sortByChanged">-->
      <!--        <Radio :label="1" style="margin:0 10px 0 0;vertical-align: top;"> {{ $t('buttons.information.time') }}</Radio>-->
      <!--        <Radio :label="2" style="margin:0 10px 0 0;vertical-align: top;"> {{ $t('buttons.information.correlationDegree') }}</Radio>-->
      <!--      </RadioGroup>-->

      <!--      el-icon-sort-up-->
      <el-link @click="sortByTime"><i :class="sortByTimeIcon" style="font-size: 14px;font-weight: 800"></i>{{
          $t('buttons.information.time')
        }}</el-link>
      <Divider type="vertical"/>
      <Checkbox v-model="isChecked" @on-change="sortByChanged">{{ $t('buttons.information.correlationDegree') }}</Checkbox>

    </span>
      <span class="fr right" @click="exportList"><span class="excel-png"></span>{{ $t('buttons.export') }}</span>
    </div>
    <div class="newInfo-list">
      <!--      <Spin v-if="tableLoading" class="pbrSpin"-->
      <!--            fix-->
      <!--            size="large">-->
      <!--      </Spin>-->
      <Table ref="infoTable" :show-header="false" :columns="columns"
             :data="tableData"
             :loading="tableLoading"
             @on-selection-change="tableSelectionChange">
        <template slot="fav" slot-scope="{ row }">
          <Icon :type="row.favStatus ? 'md-star' : 'md-star-outline'" color="#008acd"
                style="font-size: 20px;" @click="editFavorite(row)" class="pointer"/>
        </template>

        <template slot-scope="{ row, index }" slot="title">
          <div class="newInfo-list-item">

            <div v-if="row.pictureUrl" class="item-img">
              <img :src="row.pictureUrl || 'static/images/pbr/blank.png'" alt="">
            </div>
            <div class="item-detail">
              <p class="item-detail-title" @click="$router.push({
                  name: goto,
                  params: row,
                  query:{key:row.id, type: type}
                })" v-html="row.title"></p>
              <p class="item-detail-tag-box">
                <el-tag
                  v-for="(item,index) in row.typeStr.split(',')"
                  :key="item"
                  effect="plain"
                  size="small"
                  @click="tagHandler(index,row)"
                  style="margin-right: 4px;cursor:pointer;">
                  {{ item }}
                </el-tag>
                <span style="margin: 0 15px;color: #808c9a;font-size: 12px;">|</span>
                <template v-if="row.sourceType">
                  <span style="color: #808c9a;font-size: 12px;">{{ row.sourceType || '' }}</span>
                  <Divider type="vertical"/>
                </template>
                <span style="color: #808c9a;font-size: 12px;">{{ row.articleDate | format(that) }}
                  <template v-if="module === 'fxsj'">
                   {{ $t('label.information.risk.updatedTime') }} {{ row.updateDate | format(that) }}
                  </template>
                </span>
              </p>
            </div>
          </div>
        </template>
      </Table>

    </div>
    <el-pagination :current-page="currentPage" :page-size="pageSize"
                   :page-sizes="[8, 10, 20, 50, 100]" :pager-count="5" :total="totalElements"
                   layout="total, sizes, prev, pager, next, jumper" style="margin-top: 10px"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange">
    </el-pagination>
    <el-dialog :modal="false" :visible.sync="historyModal" append-to-body :title="$t('table.history.title')"
               width="600px">
      <div style="text-align: right;margin-bottom: 10px;">
        <Button @click="delAllHistory" type="primary">{{ $t('buttons.delAll') }}</Button>
      </div>
      <Table :columns="historyColumns" :data="historyTableData" border @on-row-click="historyRowDbClick"
             class="pbr-info-history-table">
        <template slot="top" slot-scope="{ row }">
          <div style="cursor:pointer;" @click.stop="toTopHistory(row)">
            <Icon :class="favIconClass(row)" style="font-size: 20px;" type="md-arrow-round-up"/>
          </div>
        </template>
        <template slot="operate" slot-scope="{ row }">
          <Icon style="font-size: 20px;cursor:pointer;" type="md-trash" @click.stop="delHistory(row)"/>
        </template>
      </Table>
    </el-dialog>
    <div v-show="false" ref="submitForm">
      <form
          method="get"
          target="_blank"
          enctype="multipart/form-data"
          :action="action"
      >
        <input name="selections" type="text"/>
        <input name="from" type="text" value="cn"/>
      </form>
    </div>
  </div>
</template>

<script>
  import {contentType, exportFile, exportFilePost} from '../apis/common'

const subTypeObj = {
  fxsj: 'riskEven',
  fx: 'riskArticle',
  sj: 'businessArticle',
  xm: 'projectArticle'
}

export default {
  name: 'PbrInfoIndexTabs',
  props: {
    hotWord: {
      type: String
    },
    country: {
      type: String
    },
    category: {
      type: String
    },
    url: {
      type: String,
      default: ''
    },
    goto: {
      type: String,
      default: 'pbrInfoDetail'
    },
    type: {
      type: String
    },
    module: {
      type: String,
      default: 'xm'
    },
    tagField: {
      type: String,
      default: 'labels'
    },
    formItems: {
      type: Array,
      default: () => {
        return [
          'countries',
          'industries',
          'enterprises',
          'categories',
          'stages',
          'amount',
          'pdate'
        ]
      }
    },
    countryId: {
      type: String
    }
  },
  data () {
    let self = this
    return {
      that: this,
      switchSearchMode: 0,
      action: this.module === 'fxsj' ? this.$pbrApis.exportRiskListExcelUrl : this.$pbrApis.exportInfoListExcelUrl,
      tableLoading: true,
      associationWordsList: [],
      searchForm: {
        industry: [],
        company: [],
        keywords: this.hotWord,
        countries: [],
        industries: [],
        enterprises: [],
        categories: [],
        stages: [],
        amount: [],
        sort: 0,
        pdate: [],
        searchModel: '0',
        source:''
      },
      infoObj: {},
      cityList: [],
      countryList: [],
      industryList: [],
      companyList: [],
      stageModels: [],
      amountModels: [],
      dateModels: [],
      typeModels: [],
      dateOptions: {
        shortcuts: [
          {
            text: this.$t('datePicker.threeMonths'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(3, 'month').format('yyyy-MM-DD')
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end]
            }
          },
          {
            text: this.$t('datePicker.oneYear'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(1, 'year').format('yyyy-MM-DD')

              return [start, end]
            }
          },
          {
            text: this.$t('datePicker.threeYears'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(3, 'year').format('yyyy-MM-DD')

              return [start, end]
            }
          }
        ]
      },
      showMoreCondition: false,
      myCondition: {},
      /**/
      newInfoAllCheck: false,
      newInfoSortBy: '',
      tags: [],
      currentPage: 1,
      /**/
      historyModal: false,
      historyColumns: [{
        title: this.$t('table.project.history.columns.top'),
        width: 50,
        slot: 'top',
        align: 'center'
      },
      {
        title: this.$t('table.history.columns.title'),
        key: 'searchCondition',
        render: (h, params) => {
          return h('span', params.row.searchCondition.replace(/,{2,}/g, ''))
        }
      },
      {
        title: this.$t('table.project.history.columns.delete'),
        width: 80,
        slot: 'operate',
        align: 'center'
      }
      ],
      historyTableData: [],
      tableData: [],
      tableSelection: [],
      pageSize: 8,
      totalPages: 0,
      totalElements: 0,
      columns: [
        {
          type: 'selection',
          width: 40,
          align: 'center'
        },
        {
          title: ' ',
          width: 30,
          slot: 'fav',
          align: 'center'
        },
        {
          title: this.$t('table.project.main.title'),
          slot: 'title'
        }
      ],
      indeterminate: false,
      checkAll: false,
      isChecked:false,
      isSortByTime: null,
      isSortByTimeDesc: false
    }
  },
  created () {
    this.queryHistorySearch()
    if (this.country) {
      this.searchForm.countries.push(this.country)
    }
    if (this.category) {
      this.searchForm.categories.push(this.category)
    }
  },
  computed: {
    isEN () {
      return localStorage.getItem('locale') === 'en'
    },
    sortByTimeIcon () {
      if (this.isSortByTime) {
        if (this.isSortByTimeDesc) {
          return 'el-icon-sort-down'
        } else {
          return 'el-icon-sort-up'
        }
      } else {
        return 'el-icon-sort  el-icon--left'
      }
    }
  },
  mounted () {
    let self = this
    this.getConditions(() => {
      self.search()
    })
  },
  activated () {

  },
  methods: {
    delAllHistory(){
      let type = {
        'sj': 'businessArticle',
        'xm': 'projectArticle',
        'fx': 'riskArticle',
        'fxsj': 'riskEven'
      }
      this.$pbrAxios.post('/front/searchHistory/delAllHistory', {"type": "front", "subtype": type[this.module]}).then((data) => {
        //this.$iMessage.success(this.$t('message.success.delete'))
        this.queryHistorySearch()
      })
    },
    tagHandler(index,row){
      this.showMoreCondition = true;
      let cat = JSON.stringify({id:row.typeId.split(',')[index],title:row.typeStr.split(',')[index]});
      this.searchForm.categories = [cat]
      setTimeout(this.search,0)

    },
    sortByTime () {
      this.isChecked = false
      this.isSortByTime = true
      this.isSortByTimeDesc = !this.isSortByTimeDesc
      this.searchForm.sort = 1
      this.searchForm.orderBy = this.isSortByTimeDesc ? 0 : 1
      this.search()
    },
    handleCheckAll (flag) {
      this.checkAll = flag
      if (flag) {
        this.$refs.infoTable.selectAll(true)
      } else {
        this.$refs.infoTable.selectAll(false)
        this.indeterminate = false
      }
    },
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    },
    associationWords (keyword) {
      if (keyword && keyword.length > 100) {
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return
      }

      // type（0项目搜索   1项目资讯搜索  2商机资讯搜索   3风险资讯搜索   4风险事件搜索  5分析页搜索）
      let types = {
        xm: 1,
        sj: 2,
        fx: 3,
        fxsj: 4
      }

      this.$pbrApis.associationWords({keyword, type: types[this.module]}).then(res => {
        if (res.success) {
          this.associationWordsList = res.result.models
        }
      })
    },
    tableSelectionChange (selection) {
      this.tableSelection = selection
      if (selection.length === this.pageSize) {
        this.indeterminate = false
        this.checkAll = true
      } else {
        this.indeterminate = true
        this.checkAll = false
      }
    },
    favIconClass (row) {
      if (row.up) {
        if (this.isDark()) {
          return {'fav-icon-dark-active': true}
        }
        return {'fav-icon-active': true}
      } else {
        if (this.isDark()) {
          return {'fav-icon-dark': true}
        }
        return {'fav-icon': true}
      }
    },
    changeType (dd) {
      console.log(dd)
    },
    maxTagPlaceholder (num) {
      return '... ' + num
    },
    moreConditionClick () {
      this.showMoreCondition = !this.showMoreCondition
    },
    sortByChanged (checked) {
      if (checked) {
        this.searchForm.sort = 2
      } else {
        this.searchForm.sort = 0
      }
      this.isSortByTime = false
      this.searchForm.orderBy = undefined
      this.search()
    },
    loadData () {
      this.$pbrApis.requestByUrl(this.url, {
        from: 'cn'
      }).then(res => {
        console.log('资讯列表', this.url, res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.infoObj = res.result
          this.tableData = this.infoObj.content
          this.totalPages = this.infoObj.totalPages
          this.totalElements = this.infoObj.totalElements
        }
      })
    },
    getConditions (callback) {
      // this.$pbrApis.fetchProjectGCondition({})
      this.$pbrApis.fetchConditionInfo({
        from: 'cn',
        index: 'zx',
        module: this.module
      }).then((data) => {
        if (!data) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (data.success) {
          this.countryList = data.result.regionModels.children
          this.industryList = data.result.industryModels
          this.companyList = data.result.enterpriseModels
          this.typeModels = data.result.typeModels
          this.amountModels = data.result.amountModels
          this.dateModels = data.result.dateModels
          this.stageModels = data.result.stageModels
        }
        callback()
      })
    },
    getSearchParams () {
      function filterSearchParams (obj) {
        let arr = []
        obj.forEach((item) => {
          arr.push(JSON.parse(item).id)
        })
        return arr
      }

      console.log('this.searchForm.countries', this.searchForm.countries)

      let param = {
        from: 'cn',
        pageNo: this.currentPage - 1,
        pageSize: this.pageSize,
        countries: filterSearchParams(this.searchForm.countries),
        industries: filterSearchParams(this.searchForm.industries),
        enterprises: filterSearchParams(this.searchForm.enterprises),
        categories: filterSearchParams(this.searchForm.categories),
        stages: filterSearchParams(this.searchForm.stages),
        amountIds: filterSearchParams(this.searchForm.amount),
        pdate: this.searchForm.pdate.join(','),
        sort: this.searchForm.sort,
        orderBy: this.searchForm.orderBy,
        keywords: this.searchForm.keywords ? this.searchForm.keywords.trim() : '',
        searchModel: this.searchForm.searchModel,
        source: this.searchForm.source
      }

      console.log('param', param)

      return param
    },
    okBtn () {
      this.currentPage = 1
      this.search()
    },
    search (paramObj) {

      if (this.searchForm.keywords && this.searchForm.keywords.length > 100) {
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return
      }
      this.tableLoading = true

      let params = {}
      if (paramObj) {
        params = paramObj
      } else {
        params = this.getSearchParams()
        let countryStr = this.myCondition.countries ? this.myCondition.countries.list.map(c => JSON.parse(c).title).join(',') : ''
        let categoryStr = this.myCondition.categories ? this.myCondition.categories.list.map(c => JSON.parse(c).title).join(',') : ''
        let industryStr = this.myCondition.industries ? this.myCondition.industries.list.map(i => JSON.parse(i).title).join(',') : ''
        let stageStr = this.myCondition.stages ? this.myCondition.stages.list.map(s => JSON.parse(s).title).join(',') : ''
        let enterpriseStr = this.myCondition.enterprises ? this.myCondition.enterprises.list.map(e => JSON.parse(e).title).join(',') : ''
        let amountStr = this.myCondition.amount ? this.myCondition.amount.list.map(a => JSON.parse(a).title).join(',') : ''
        // let timeStr = this.myCondition.date ? this.myCondition.date.list.map(t => JSON.parse(t).title).join(',') : ''
        params = {...params, countryStr, categoryStr, industryStr, stageStr, enterpriseStr, amountStr}
      }

      this.$pbrApis.requestByUrl(this.url, params)
        .then(res => {
          console.log('资讯列表', this.url, res)
          if (!res) {
            //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
          } else if (res.success) {
            this.tableLoading = false
            this.infoObj = res.result
            this.tableData = this.infoObj.content
            this.totalPages = this.infoObj.totalPages
            this.totalElements = this.infoObj.totalElements

            // 保存搜索记录
            params.subType = subTypeObj[this.module]
            return this.$pbrApis.saveRiskSearchHistory(params)
          }
        }).then(resHistory => {
          console.log(resHistory)
        })

        this.$emit('search',params)
    },
    reset () {
      this.searchForm = {
        industry: [],
        keywords: '',
        country: [],
        countries: [],
        industries: [],
        enterprises: [],
        categories: [],
        stages: [],
        startTime: '',
        endTime: '',
        amountIds: [],
        sort: '',
        amount: [],
        pdate: [],
        searchModel: '0',
        source:''
      }
      this.currentPage = 1
      this.search()
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.currentPage = 1
      this.search()
    },
    handleCurrentChange (val) {
      if (val < 1) {
        this.currentPage = 1
      } else if (val > this.totalPages) {
        this.currentPage = this.totalPages
      } else {
        this.currentPage = val
      }
      this.search()
      console.log(`当前页: ${val}`)
    },
    /**/
    openHistory () {
      this.historyModal = true
      this.queryHistorySearch()
    },
    queryHistorySearch () {
      let type = {
        'sj': 'businessArticle',
        'xm': 'projectArticle',
        'fx': 'riskArticle',
        'fxsj': 'riskEven'
      }
      this.$pbrApis.queryHistorySearch({pageSize: 10, pageNo: 0, 'type': type[this.module]}).then(res => {
        console.log('获取项目搜索历史：', res)
        if (!res) {
        } else if (res.code === 200) {
          this.historyTableData = res.result.records
        } else {
        }
      })
    },
    updateHistorySearch (row) {
      let formData = new FormData()
      formData.append('id', row.id)
      formData.append('_method', 'PUT')

      this.$pbrApis.updateHistorySearch({id: row.id, isUp: !row.up}).then(res => {
        console.log('置顶项目：', res)
        if (!res) {
        } else if (res.code === 200) {
          //this.$iMessage.success(!row.up ? this.$t('message.success.up') : this.$t('message.success.unUp'))
          this.queryHistorySearch()
        } else {
        }
      })
    },
    deleteHistorySearch (row) {
      this.$pbrApis.deleteHistorySearch({id: row.id}).then(res => {
        console.log('删除项目：', res)
        if (!res) {
        } else if (res.code === 200) {
          //this.$iMessage.success(this.$t('message.success.delete'))
          this.queryHistorySearch()
        } else {
        }
      })
    },
    historyRowDbClick (data, index) {
      console.log(data)
      let obj = JSON.parse(data.searchConditionObj)
      let countries = obj.countries.map((id, i) => JSON.stringify({id, title: obj.countryStr.split(',')[i]}))
      let industries = obj.industries.map((id, i) => JSON.stringify({id, title: obj.industryStr.split(',')[i]}))
      let enterprises = obj.enterprises.map((id, i) => JSON.stringify({id, title: obj.enterprise.split(',')[i]}))
      let categories = obj.categories.map((id, i) => JSON.stringify({id, title: obj.categoryStr.split(',')[i]}))
      let stages = obj.stages.map((id, i) => JSON.stringify({id, title: obj.stageStr.split(',')[i]}))
      // let date = obj.timeIds.map((id, i) => JSON.stringify({id, title: obj.timeStr.split(',')[i]}))
      let amount = obj.amountIds.map((id, i) => JSON.stringify({id, title: obj.amountStr.split(',')[i]}))
      let pdate = obj.pdate ? obj.pdate.split(',') : []
      let source = obj.source

      this.search(JSON.parse(data.searchConditionObj))
      this.searchForm = {
        ...obj,
        countries,
        industries,
        enterprises,
        categories,
        stages,
        pdate,
        amount,
        source
      }
      this.historyModal = false
      this.showMoreCondition = true;
    },
    toTopHistory (row) {
      this.updateHistorySearch(row)
    },
    delHistory (row) {
      this.deleteHistorySearch(row)
    },
    editFavorite (row) {
      let option = row.favStatus ? 'delete' : 'add'
      let type = {
        'sj': 5,
        'xm': 5,
        'fx': 5,
        'fxsj': 4
      }

      this.$pbrApis.editFavorite(option, {id: row.id, type: type[this.module]}).then(res => {
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.favorite'), duration: 5})
        } else if (res.code === 200) {
          console.log('收藏', res)
          // this.$iMessage.success({
          //   content: option === 'add' ? this.$t('message.success.favorite') : this.$t('message.success.unfavored'),
          //   duration: 5
          // })
          this.search()
        }
      }).catch(err => {
        //this.$iMessage.error({content: err.message, duration: 5})
      })
    },
    exportList () {
      let that = this
      if (this.tableSelection.length === 0) {
        this.$confirm(that.$t('message.warning.prompt.export'), that.$t('message.warning.prompt.title'), {
          confirmButtonText: that.$t('buttons.ok'),
          cancelButtonText: that.$t('buttons.cancel'),
          type: 'warning'
        }).then(() => {
          let paramss = this.getSearchParams()
          paramss.type = this.module
          exportFilePost(this.action, paramss, `${this.$t('label.export.infoList')}-${this.module}`, contentType.excel, '.xlsx', (err) => {
            if (err) {
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: that.$t('message.warning.prompt.exportFailure')
          })
        })
      } else {
        let selectionIds = this.tableSelection.map(t => t.id)
        // let form = $(this.$refs.submitForm).find('form')
        // form.find('input[name=\'selections\']').val(selectionIds.join(','))
        // form.submit()
        exportFile(this.action, {
          selections: selectionIds.join(','),
          type: this.module
        }, `${this.$t('label.export.infoList')}-${this.module}`, contentType.excel, '.xlsx')
      }
    }
  },
  filters: {
    format: function (value, vue) {
      // if (that.$moment(value).isValid()) {
      //   return that.$moment(value).format('yyyy-MM-DD')
      // }
      // return value
      if (value && value !== '--') {
        return vue.$moment(value).format('yyyy-MM-DD')
      }
      return value
    }
  },
  watch: {
    hotWord: {
      handler (newV, oldV) {
        if (newV && newV.trim().length > 0) {
          this.searchForm.keywords = newV
          this.search()
        }
      },
      immediate: true
    },
    // url: {
    //   handler (newV, oldV) {
    //     if (newV && newV.trim().length > 0) {
    //       this.search()
    //     }
    //   },
    //   immediate: true
    // },
    // country: {
    //   handler (newV, oldV) {
    //
    //     if (newV && newV.trim().length > 0) {
    //
    //       this.search()
    //     }
    //   },
    //   immediate: true
    // },
    'searchForm.countries' (val) {
      if (val && val.length > 0) {
        this.myCondition.countries = {
          tag: this.$t('label.country'),
          list: val
        }
      } else {
        delete this.myCondition.countries
      }
    },
    'searchForm.industries' (val) {
      if (val && val.length > 0) {
        this.myCondition.industries = {
          tag: this.$t('label.industry'),
          list: val
        }
      } else {
        delete this.myCondition.industries
      }
    },
    'searchForm.enterprises' (val) {
      if (val && val.length > 0) {
        this.myCondition.enterprises = {
          tag: this.$t('label.enterprise'),
          list: val
        }
      } else {
        delete this.myCondition.enterprises
      }
    },
    'searchForm.categories' (val) {
      if (val && val.length > 0) {
        this.myCondition.categories = {
          tag: this.$t('label.information.category'),
          list: val
        }
      } else {
        delete this.myCondition.categories
      }
    },
    'searchForm.stages' (val) {
      if (val && val.length > 0) {
        this.myCondition.stages = {
          tag: this.$t('label.stage'),
          list: val
        }
      } else {
        delete this.myCondition.stages
      }
    },
    'searchForm.amount' (val) {
      if (val && val.length > 0) {
        this.myCondition.amount = {
          tag: this.$t('label.amount'),
          list: val
        }
      } else {
        delete this.myCondition.amount
      }
    },
    'searchForm.pdate' (val) {
      if (val && val.length > 0 && val[0]) {
        this.myCondition.pdate = {
          tag: this.$t('label.theDateRange'),
          list: val
        }
      } else {
        delete this.myCondition.pdate
      }
    },
    'searchForm.source' (val) {
      if (val) {
        this.myCondition.source = {
          tag: this.$t('label.source'),
          list: val
        }
      } else {
        delete this.myCondition.source
      }
    }
  }
}
</script>

<style scoped>
.condition-container {
  position: relative;
  overflow: hidden;
  transition: all 0.2s linear;
}

.show-more {
  height: 150px;
}


.pbr-info-history-table >>> .ivu-table td {
  cursor: pointer;
}

.ivu-switch-inner-en {
  left: -3px;
  position: absolute;
}
</style>
